module.exports = __webpack_public_path__ + "img/logo-hjp-white.05b33ddc.png";